// import Button from "@/lib/components/Button";
import ImageGrid from "@/lib/components/home/MostPopularDestinations/ImageGrid";
import Text from "@/lib/components/Text";
import { Urls } from "@/lib/constants/urls";
import { useLanguage } from "@/lib/hooks/useLanguage";
import { useTailwindBreakpoint } from "@/lib/hooks/useTailwindBreakpoint";
import { useTranslation } from "@/lib/i18n/client";
import { PopularCity } from "@/lib/types/PopularCity";

type Props = {
    mostPopular: PopularCity[] | undefined;
};

const NoResults = ({ mostPopular }: Props) => {
    const lang = useLanguage();
    const { t } = useTranslation(lang, "search");
    const currentBreakpoint = useTailwindBreakpoint()[1];

    return (
        <div className="flex flex-col grow text-center justify-center w-full items-center">
            <div className="flex flex-col gap-6 justify-center w-full items-center">
                <Text as="h3" className="font-bold px-5">
                    {t("no-results.title")}
                </Text>
                {/* We don't have logic for searching by location yet, so displaying same as desktop */}
                {/* <Button className="px-10 py-5 h-16 flex lg:hidden font-medium">{t("searchNearby")}</Button> */}
            </div>
            <Text as="p" className="lg:flex font-medium text-xl pt-2">
                {t("exploreCities")}
            </Text>
            <div className="sm:flex w-full px-8 2xl:px-40 lg:px-20 py-8 md:py-20 lg:pb-8 lg:pt-2">
                <ImageGrid items={mostPopular?.slice(0, currentBreakpoint === "sm" ? 2 : 3) ?? []} />
            </div>
            <a href={Urls.inquiry.index} className="font-medium text-base text-white">
                <div className="mx-auto bg-primary-500 hover:bg-primary-400 p-5 rounded-md">{t("inquiry")}</div>
            </a>
        </div>
    );
};

export default NoResults;
